import React, { Component } from "react";
import { Placeholder } from "semantic-ui-react";
import { isEmpty } from "lodash";
import ReadAxios from "../../axiosComponent/read";

export class VendorName extends Component {
  constructor(props) {
    super(props);

    this.state = {
      vendorName: null,
    };
  }

  componentDidMount() {
    this.getVendorName();
  }

  getVendorName = () => {
    ReadAxios({ url: `transporterMaster/${this.props.vendorID}` })
      .then((res) => {
        return (
          isEmpty(res.data.resultSet)
            ? "NA"
            : this.props.vendorNameCallback &&
              this.props.vendorNameCallback(
                res.data.resultSet[0].transporterName
              ),
          this.setState({
            vendorName: res.data.resultSet[0].transporterName,
          })
        );
      })
      .catch((err) => {
        return "NA";
      });
  };

  render() {
    return this.state.vendorName ? (
      <>{this.state.vendorName}</>
    ) : (
      <Placeholder fluid>
        <Placeholder.Header>
          <Placeholder.Line />
        </Placeholder.Header>
      </Placeholder>
    );
  }
}

export default VendorName;
